// @flow
import { put, fork, all } from 'redux-saga/effects'

import { combineReducers } from 'redux'
// $FlowFixMe
import { reducer as formReducer } from 'redux-form'
// $FlowFixMe
import { routerReducer } from 'react-router-redux'

import locationsReducer, { fetchLocationsSaga } from './locations'
import bookingReducer from 'src/ducks/booking'
import encryptionReducer, { encryptionSaga, decryptValues } from 'src/ducks/encryption'
import stripeReducer, { watchStripe } from 'src/ducks/stripe'
import authReducer, { authSaga } from 'src/ducks/auth'

export const rootReducer = combineReducers({
  form: formReducer,
  router: routerReducer,
  auth: authReducer,
  locations: locationsReducer,
  booking: bookingReducer,
  stripe: stripeReducer,
  encryption: encryptionReducer
})

// $FlowFixMe
export function* rootSaga() {
  yield all([fetchLocationsSaga, watchStripe, encryptionSaga, authSaga].map(fork))
  yield put(decryptValues())
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/ducks/index.js